import { ArrowRight, Check } from 'lucide-react';

export const ProductCard = ({ 
  name = "Product Name",
  description = "A brief description of the product and its key benefits.",
  bestFor = "All Skin Types",
  benefits = ["Benefit one", "Benefit two", "Benefit three"],
  imageUrl = null,
  affiliateLink = "#",
  isPlaceholder = false
}) => {
  const hasRealLink = affiliateLink && affiliateLink !== "#";
  
  return (
    <div 
      data-testid="product-card"
      className="group bg-white border border-[#E5E5E5] overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-[#C88D74]/30"
    >
      {/* Image Section */}
      <div className="aspect-[4/3] bg-[#F2EBE3] overflow-hidden relative flex items-center justify-center">
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={name}
            className="w-full h-full object-contain p-4 transition-all duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#6B7280] p-6">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-2 rounded-full bg-[#E5E5E5] flex items-center justify-center">
                <svg className="w-8 h-8 text-[#9CA3AF]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <span className="font-accent italic text-sm">Category Example</span>
            </div>
          </div>
        )}
      </div>
      
      {/* Content Section */}
      <div className="p-5 md:p-6">
        {/* Best For Badge */}
        <span className="inline-block px-3 py-1 bg-[#F2EBE3] text-[#3A4D39] text-xs font-medium tracking-wide uppercase mb-3">
          Best for: {bestFor}
        </span>
        
        {/* Title */}
        <h3 className="font-heading text-xl md:text-2xl font-semibold text-[#1C1C1C] mb-2 leading-tight">
          {name}
        </h3>
        
        {/* Description */}
        <p className="text-[#374151] text-sm md:text-base mb-4 leading-relaxed">
          {description}
        </p>
        
        {/* Benefits List */}
        <ul className="space-y-2 mb-5">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-[#374151]">
              <Check className="w-4 h-4 text-[#3A4D39] mt-0.5 flex-shrink-0" />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
        
        {/* CTA Button - Only show for products with real affiliate links */}
        {hasRealLink ? (
          <a 
            href={affiliateLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="product-affiliate-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-[#3A4D39] text-[#3A4D39] text-sm font-medium tracking-wide uppercase transition-all duration-300 hover:bg-[#3A4D39] hover:text-white group/btn"
          >
            View Product
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
          </a>
        ) : (
          <p className="text-xs text-[#6B7280] italic font-accent leading-relaxed">
            Product examples shown are for category illustration purposes. Specific recommendations will be added soon.
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
